import { render, staticRenderFns } from "./SchoolDetail.vue?vue&type=template&id=9293983e&scoped=true"
import script from "./SchoolDetail.vue?vue&type=script&lang=js"
export * from "./SchoolDetail.vue?vue&type=script&lang=js"
import style0 from "./SchoolDetail.vue?vue&type=style&index=0&id=9293983e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9293983e",
  null
  
)

export default component.exports